import { getLoyaltyLevelNumber } from '~~/helpers/getLoyaltyLevelNumber';
import type { LoyaltyPoints } from '~~/types/loyaltyPoints/loyaltyPoints';

export const getNextLoyaltyLevelNumber = (
  { monetaryCohortGroup, pointsToNextLevel }: Pick<LoyaltyPoints, 'monetaryCohortGroup' | 'pointsToNextLevel'>,
): number | null => {

  if (pointsToNextLevel === null || monetaryCohortGroup === null) {

    return null;

  }

  return getLoyaltyLevelNumber(monetaryCohortGroup) + 1;

};
